import { graphql } from 'gql.tada';
import { useQuery } from '@apollo/client';

const SchoolAttendanceReportQuery = graphql.persisted(
  "SchoolAttendanceReport",
  graphql(`query SchoolAttendanceReport($schoolYearId: ID!, $fromDate: ISO8601Date!, $toDate: ISO8601Date!) {
    schoolYear(id: $schoolYearId) {
      id
      schoolAttendanceReport(fromDate: $fromDate, toDate: $toDate) {
        fromDate
        toDate
        recordedDayCount
        students {
          person { id firstName lastName }
          presentCount
          absentCount
          tardyCount
          excusedCount
          recordedCount
          attendanceRate
        }
        days {
          date
          presentCount
          absentCount
          tardyCount
          excusedCount
          recordedCount
        }
        missingRolls {
          date
          scheduleBlock { id displayTitle timeLabel }
        }
      }
    }
  }`)
);

export { SchoolAttendanceReportQuery };

export function useSchoolAttendanceReport(schoolYearId?: string, fromDate?: string, toDate?: string) {
  return useQuery(SchoolAttendanceReportQuery, {
    variables: { schoolYearId: schoolYearId!, fromDate: fromDate!, toDate: toDate! },
    skip: !schoolYearId || !fromDate || !toDate,
  });
}
